import React, {Component} from 'react';
import {getLoadingMessageImages} from '../utils';

const LoadingMessage = () => {
  const [LoadingMesageImage] = getLoadingMessageImages();

  return (
    <div className="map-page-content" id="message-loading">
      <img src={LoadingMesageImage} alt="" width="110" height="110" />
      <h4>Loading...</h4>
    </div>
  );
};

export default LoadingMessage;



// WEBPACK FOOTER //
// ./src/components/LoadingMessage.js